import { Button, CardActions, CardContent, FormControlLabel, Switch } from "@material-ui/core";
import React, { Component } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { compose } from "redux";
import { Field, reduxForm, SubmissionError } from "redux-form";
import { createNumberMask } from "redux-form-input-masks";
import * as actions from "../actions";
import CustomInputForm from "../custom/CustomInput";
import FieldWithTooltip from "../custom/FieldWithTooltip";
import HeaderPageItem from "../custom/HeaderPageItem";
import PageContainer, { CardPageItem } from "../custom/Page";
import { numberNormalizer, resolveListErrors } from "../util";
import { validateMin, validateNumberLimits, validatePeriod, validateRequired, validateTime } from "../util/validations";

// VERIFICADO LCTInputMask - precisou chamar o getConfig.

class ConfigForm extends Component {
  componentDidMount() {
    const { getConfig } = this.props;
    getConfig();
  }

  onSubmit = async (formProps) => {
    const { history, showErrorMessage, showSuccessMessage } = this.props;

    const submitParams = {
      ...formProps,
      withdrawalFeePercentage: formProps.withdrawalFeePercentage / 100,
      maxFinePercentage: formProps.maxFinePercentage / 100,
    };

    try {
      await actions.updateConfig(submitParams);
      showSuccessMessage("app.update");

      history.push("/more");
    } catch (e) {
      const errors = resolveListErrors(e);
      showErrorMessage("app.form.erros");

      const formErrors = errors.reduce((acc, error) => {
        if (error.field) {
          acc[error.field] = error.message;
        }

        return acc;
      }, {});

      throw new SubmissionError({
        ...formErrors,
        _error: "confira o form",
      });
    }
  };

  render() {
    const { handleSubmit, config } = this.props;
    if (!config.LCTInputMask) return null;
    const percentualMask = createNumberMask({
      suffix: "%",
      decimalPlaces: 2,
      locale: "pt-BR",
      allowNegative: false,
    });
    const lctMask = config.LCTInputMask();
    return (
      <PageContainer>
        <HeaderPageItem title="app.config.title" showBackButton destination="/more" />
        <CardPageItem>
          <CardContent>
            <form onSubmit={handleSubmit(this.onSubmit)} noValidate>
              <Field
                name="address"
                label="app.company.wallet.address"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressUsdtTrx"
                label="app.company.wallet.address.trx"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressUsdtEth"
                label="app.company.wallet.address.eth"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressUsdtBnb"
                label="app.company.wallet.address.bnb"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressEth"
                label="app.company.wallet.address.ether"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="partnerAddress"
                label="app.wallet.address.partner"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressUSDC_ETH"
                label="app.company.wallet.address.USDC_ETH"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressUSDT_POL"
                label="app.company.wallet.address.usdtPolygon"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressUSDC_POL"
                label="app.company.wallet.address.usdcPolygon"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              <Field
                name="addressPOL_POL"
                label="app.company.wallet.address.polPolygon"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              />
              {/* <Field
                name="addressUSDC_TRX"
                label="app.company.wallet.address.USDC_TRX"
                InputLabelProps={{
                  shrink: true,
                }}
                component={CustomInputForm}
              /> */}
              <Field
                name="minConsultantWithdraw"
                label="app.agent.withdraw.min"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                {...lctMask}
                />
              <Field
                name="minCustomerWithdraw"
                label="app.customer.withdraw.min"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                {...lctMask}
                />
              <Field
                name="maxFinePercentage"
                label="app.customer.fine.max"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                {...percentualMask}
                />
              <Field
                name="withdrawalFeePercentage"
                label="app.customer.withdraw.fee"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                {...percentualMask}
                />
              <Field
                name="maxWithdrawalFeeAmount"
                label="app.customer.withdraw.fee.max"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                {...lctMask}
                />
              <Field
                name="redemptionDelay"
                label="app.paymentDelay"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                normalize={numberNormalizer}
                />

              <Field
                name="startTime"
                label="app.initialWorkHour"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                type="time"
                />
              <Field
                name="finishTime"
                label="app.finalWorkHour"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={CustomInputForm}
                type="time"
                />
              <Field
                name="isSumsubKYCEnabled"
                label="app.enableSumsub"
                InputLabelProps={{
                  shrink: true,
                  required: true,
                }}
                component={({input}) => (
                  <FormControlLabel 
                    control={
                      <Switch
                        {...input}
                        checked={!!input.value}
                        onChange={(_, checked) => input.onChange(checked)}
                        color="primary"
                      />
                    }
                    label={<FormattedMessage id={"app.enableSumsub"} />}
                  />
                )}
                />

              <FieldWithTooltip tooltip="app.config.inviteExpirationHours.help">
                <Field
                  name="inviteExpirationHours"
                  label="app.config.inviteExpirationHours"
                  InputLabelProps={{
                    shrink: true,
                    required: true,
                  }}
                  component={CustomInputForm}
                  normalize={numberNormalizer}
                />
              </FieldWithTooltip>

              <CardActions>
                <Button fullWidth id="bSubmitOrderForm" variant="contained" color="primary" type="submit">
                  <FormattedMessage id="app.button.save" />
                </Button>
              </CardActions>
            </form>
          </CardContent>
        </CardPageItem>
      </PageContainer>
    );
  }
}

const ERROR_KEY = "app.form.config";

const validate = (values, props) => {
  const errors = {};

  // validateRequired({ values, errors, field: "address", errorKey: "app.wallet.inform" });
  // validateRequired({ values, errors, field: "addressUsdtTrx", errorKey: ERROR_KEY });
  // validateRequired({ values, errors, field: "addressUsdtEth", errorKey: ERROR_KEY });
  // validateRequired({ values, errors, field: "addressUsdtBnb", errorKey: ERROR_KEY });
  // validateRequired({ values, errors, field: "addressEth", errorKey: ERROR_KEY });
  // validateRequired({ values, errors, field: "partnerAddress", errorKey: "app.wallet.inform" });

  // validateRequired({ values, errors, field: "addressUSDC_ETH", errorKey: ERROR_KEY });

  // validateRequired({ values, errors, field: "addressUSDC_POL", errorKey: ERROR_KEY });
  // validateRequired({ values, errors, field: "addressUSDT_POL", errorKey: ERROR_KEY });
  // validateRequired({ values, errors, field: "addressPOL_POL", errorKey: ERROR_KEY });

  validateMin({ values, errors, field: "inviteExpirationHours", min: 1, errorKey: ERROR_KEY });
  validateMin({ values, errors, field: "maxWithdrawalFeeAmount", min: 0, errorKey: ERROR_KEY });
  validateMin({ values, errors, field: "minConsultantWithdraw", min: 0, errorKey: ERROR_KEY });
  validateMin({ values, errors, field: "minCustomerWithdraw", min: 0, errorKey: ERROR_KEY });
  validateMin({ values, errors, field: "redemptionDelay", min: 1, errorKey: ERROR_KEY });

  validateNumberLimits({ values, errors, field: "maxFinePercentage", min: 0, max: 100, errorKey: ERROR_KEY });
  validateNumberLimits({ values, errors, field: "withdrawalFeePercentage", min: 0, max: 100, errorKey: ERROR_KEY });

  validateTime({ values, errors, field: "startTime", errorKey: ERROR_KEY });
  validateTime({ values, errors, field: "finishTime", errorKey: ERROR_KEY });
  validatePeriod({ values, errors, startField: "startTime", endField: "finishTime", errorKey: ERROR_KEY });

  return errors;
};

function mapStateToProps(state) {
  return {
    config: state.config,
    initialValues: state.config,
  };
}

export default compose(
  connect(mapStateToProps, actions),
  reduxForm({
    form: "configForm",
    enableReinitialize: true,
    validate,
  }),
)(ConfigForm);
